module.exports = __webpack_public_path__ + "img/jj1.95d0b837.png";